import http from "@/utils/http";

// 分页查询
export function orgList(data) {
  return http({
    url: "/admin/orgs" + data,
    method: "GET"
  });
}

// 实名认证审核列表
export function orgIdentifys(data) {
  return http({
    url: "/admin/org/identifys" + data,
    method: "GET"
  });
}

// 获取指定机构的微信公众号授权信息
export function orgWechatInfo(data) {
  return http({
    url: "/admin/wxAuthor?orgid=" + data,
    method: "GET"
  });
}

// 通过认证
export function orgAdoptIdentifys(data) {
  return http({
    url: "/admin/org/identify/pass?orgid=" + data,
    method: "POST"
  });
}

// 编辑认证信息
export function EditOrgIdentifyInfo(id, data) {
  return http({
    url: "/admin/org/identify/edite?orgid=" + id,
    method: "POST",
    data
  });
}

// 拒绝认证
export function orgRefuseIdentifys(data) {
  return http({
    url: "/admin/org/identify/refuse",
    method: "POST",
    data
  });
}

// 获取域名列表
export function getDomainList(data) {
  return http({
    url: "/admin/org/domain/applays" + data,
    method: "GET"
  });
}

// 编辑域名
export function EditorgDomain(id, data) {
  return http({
    url: "/admin/org/domain/edite?orgid=" + id,
    method: "POST",
    data
  });
}

// 完成域名映射
export function finishDomain(id) {
  return http({
    url: "/admin/org/domain/confirm?orgid=" + id,
    method: "POST"
  });
}
